if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._isHandlingPopstate = false;

        // Listen for browser back/forward
        this._popstateHandler = this._onPopState.bind(this);
        window.addEventListener('popstate', this._popstateHandler);
      }

      connectedCallback() {
        super.connectedCallback();
        // On page load, if hash has fullscreen=show, open the modal
        if (window.location.hash === '#fullscreen=show') {
          // Small delay to ensure DOM is ready
          requestAnimationFrame(() => {
            const firstOpener = document.querySelector('modal-opener[data-modal="#' + this.id + '"] button');
            if (firstOpener) {
              this._isHandlingPopstate = true;
              this.show(firstOpener);
              this._isHandlingPopstate = false;
            }
          });
        }
      }

      hide() {
        super.hide();
        // Remove #fullscreen=show from URL
        if (window.location.hash === '#fullscreen=show') {
          if (this._isHandlingPopstate) {
            // Already navigating via popstate, just clean the hash
            return;
          }
          // Push a clean state (go back removes the hash entry)
          history.back();
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        // Add #fullscreen=show to URL via pushState
        if (!this._isHandlingPopstate && window.location.hash !== '#fullscreen=show') {
          history.pushState({ productModalOpen: true }, '', window.location.pathname + window.location.search + '#fullscreen=show');
        }
      }

      _onPopState(event) {
        const hashIsFullscreen = window.location.hash === '#fullscreen=show';

        if (!hashIsFullscreen && this.hasAttribute('open')) {
          // Browser back was pressed — close the modal without modifying history again
          this._isHandlingPopstate = true;
          super.hide();
          this._isHandlingPopstate = false;
        } else if (hashIsFullscreen && !this.hasAttribute('open')) {
          // Browser forward was pressed — reopen the modal
          const firstOpener = document.querySelector('modal-opener[data-modal="#' + this.id + '"] button');
          if (firstOpener) {
            this._isHandlingPopstate = true;
            this.show(firstOpener);
            this._isHandlingPopstate = false;
          }
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
